import React from 'react';
import { CountdownBanner } from '../components/CountdownBanner';
import { HeroSection } from '../components/HeroSection';
import { ContentSections } from '../components/ContentSections';
import { RegistrationSection } from '../components/RegistrationSection';
import { FAQSection } from '../components/FAQSection';
export function LandingPage() {
  return <div className="min-h-screen bg-brand-dark font-sans selection:bg-brand-pink/30 selection:text-white" data-id="element-128">
      <CountdownBanner data-id="element-129" />
      <main data-id="element-130">
        <HeroSection data-id="element-131" />
        <ContentSections data-id="element-132" />
        <RegistrationSection data-id="element-133" />
        <FAQSection data-id="element-134" />
      </main>
      <footer className="bg-black py-8 text-center text-gray-500 text-sm border-t border-white/5" data-id="element-135">
        <p data-id="element-136">
          © 2026 Cumbre de Inversión Inmobiliaria. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}